import * as React from 'react'
import { Text, StackChildren, Inset, Colors } from '@doordash/design-language'
import ListCell from '@doordash/component-list-cell'

export const IconListCell = ({ icon, string, color = Colors.SystemBlack }) => (
  <ListCell
    iconStart={{ type: icon, color }}
    iconAlignment={ListCell.Alignment.FlexStart}
    isSubtextFirst={true}
    isSeparatorVisible={false}
    isSquished
    subtextMaxLines={10}
    subtext={<ContentText>{string}</ContentText>}
    insetSize={ListCell.InsetSizes.None}
  />
)

export const ContentText = ({ children }) => (
  <Text styles={Text.Styles.SectionSubtext} color={Colors.TextSecondary}>
    {children}
  </Text>
)
export const SectionContainer = ({ children }) => (
  <Inset size={Inset.Sizes.Medium} isSquished>
    <StackChildren>{children}</StackChildren>
  </Inset>
)

export const CommonTextUrl = props => (
  <Text
    style={{ textDecoration: 'none' }}
    href={props.url}
    display={Text.DisplayModes.Inline}
    styles={Text.Styles.SectionSubtext}
    color={Text.Colors.SystemRed60}
    tag={'a'}
    target={'_blank'}
  >
    {props.children}
  </Text>
)
